import styled from "styled-components";
import { TableContainer as GlobalTableContainer } from "../../../../components/Table/styles";
import { Colors } from "../../../../shared/colors/colors";
import { Fonts } from "../../../../shared/fonts/fonts";

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;
export const ContainerButtons = styled.div`
  /* margin-bottom: 16px; */
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35vh;
  width: 90vw;
`;

export const ContainerCheckbox = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelCheckbox = styled.label`
  border-collapse: collapse;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  font-weight: 600;
  color: ${Colors.label};
  font-family: ${Fonts.primary};
`;

// // Componentes de modal personalizados com menos padding nas laterais
// export const ModalContainer = styled(GlobalModalContainer)`
//   // Mantém as mesmas propriedades do componente global
// `;

// export const ModalContent = styled(GlobalModalContent)`
//   padding: 64px 32px; // Reduzido de 64px para 32px nos lados
//   max-width: 85%; // Limita a largura máxima
//   width: 1100px; // Define uma largura fixa menor que o padrão
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); // Adiciona sombra para melhor aparência
// `;

// export const ModalBody = styled(GlobalModalBody)`
//   padding: 32px 20px; // Reduzido de 32px para 20px nos lados
//   overflow-x: hidden; // Previne rolagem horizontal no corpo do modal
// `;

// Container de tabela personalizado para o ModalDetalhes
export const CustomTableContainer = styled(GlobalTableContainer)`
  width: 100%;
  overflow-x: auto; // Adiciona rolagem horizontal quando necessário
  max-width: 100%; // Garante que a tabela não ultrapasse o modal
  margin-bottom: 1rem;
  border-radius: 4px;

  // Esconde a barra de rolagem no Chrome, Safari e Opera
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  table {
    width: 100%;
    min-width: 800px; // Tamanho mínimo para mostrar a rolagem
    table-layout: auto; // Permite que as colunas se ajustem ao conteúdo
  }

  th {
    white-space: nowrap; // Evita quebra de linha nos cabeçalhos
    font-weight: 600;
  }

  td {
    word-wrap: break-word; // Quebra palavras longas
    max-width: 200px; // Limita a largura máxima das células
    overflow: hidden;
    text-overflow: ellipsis; // Adiciona "..." quando o texto não cabe
  }
`;


export const AppliedFilters = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  box-sizing: border-box;
  background: rgba(249, 250, 251, 1);
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
  margin-top: 16px;

  & > p {
    margin: 0;
    white-space: nowrap;
  }

  & > i.fa.fa-filter {
    color: rgba(107, 114, 128, 1);
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FilterKey = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const FilterRemoveButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`;
